import { render, staticRenderFns } from "./VendorModal.vue?vue&type=template&id=d74986f0&scoped=true"
import script from "./VendorModal.vue?vue&type=script&lang=js"
export * from "./VendorModal.vue?vue&type=script&lang=js"
import style0 from "./VendorModal.vue?vue&type=style&index=0&id=d74986f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74986f0",
  null
  
)

export default component.exports